export default (state = {}) => {
  return {
    ...state,
    isPopoverOpen: false,
  };
};
